'use client';

/**
 * @module
 * @category Component
 */

import 'BomdisoftComponents/dialogs/styles.css';
import { Dialog, DialogContent } from 'BomdisoftComponents/dialog/index';
import { SharedDialogsEnum, useSharedDialogStore } from 'BomdisoftComponents/dialogs/store';
import { TermsOfService } from 'BomdisoftComponents/terms-of-service/index';

type TermsOfServiceDialogProps = {
  companyName: string;
  supportEmail: string;
  lang?: string;
};

export const TermsOfServiceDialog = ({ companyName, supportEmail }: TermsOfServiceDialogProps) => {
  const activeDialog = useSharedDialogStore(store => store.activeDialog);
  const closeDialog = useSharedDialogStore(store => store.closeDialog);

  return (
    <Dialog className='bomdisoft-dialogs-content-dialog' onClose={closeDialog} open={activeDialog === SharedDialogsEnum.TERMS_OF_SERVICE}>
      <DialogContent className='bomdisoft-dialogs-content'>
        <TermsOfService companyName={companyName} supportEmail={supportEmail} />
      </DialogContent>
    </Dialog>
  );
};
